import React from 'react'

import { DisapprovedLia, PendingLia } from './components'
import { ApprovedLia, ReviewLia } from '../../components'

import constants from 'constants/index'

const BalancingSafeguarding = ({
  dataProcess = {},
  questionsDisapprovedAnswers = [],
  questions = [],
  questionsPendingAnswers = [],
  questionsApprovedAnswers = [],
  answersReviewAndApproved = [],
  questionsReviewDisapprovedAnswers = [],
  show = false,
}) => {
  const {
    PENDING_LIA,
    DISAPPROVED_LIA,
    REVIEW_LIA_CLIENT,
    APPROVED_STATUS,
    REVIEW_LIA_DPO,
  } = constants.dataProcess

  const statusPendingLia = dataProcess?.statusId === PENDING_LIA
  const statusDisapprovedLia = dataProcess?.statusId === DISAPPROVED_LIA
  const statusReviewLia = dataProcess?.statusId === REVIEW_LIA_CLIENT
  const statusApproved = dataProcess?.statusId === APPROVED_STATUS
  const statusReviewDpo = dataProcess?.statusId === REVIEW_LIA_DPO

  return (
    <>
      {statusPendingLia && (
        <PendingLia
          dataProcess={dataProcess}
          questions={questions}
          questionsPendingAnswers={questionsPendingAnswers}
          questionsApprovedAnswers={questionsApprovedAnswers}
          show={show}
        />
      )}
      {statusDisapprovedLia && (
        <DisapprovedLia
          dataProcess={dataProcess}
          questionsDisapprovedAnswers={questionsDisapprovedAnswers}
        />
      )}
      {statusReviewLia && (
        <ReviewLia
          questionsPendingAnswers={questionsPendingAnswers}
          questionsReviewDisapprovedAnswers={questionsReviewDisapprovedAnswers}
          questionsApprovedAnswers={questionsApprovedAnswers}
        />
      )}
      {(statusApproved || statusReviewDpo) && (
        <ApprovedLia
          answersReviewAndApproved={answersReviewAndApproved}
          questions={questions}
        />
      )}
    </>
  )
}

export default BalancingSafeguarding
